function pageLanguage() {
  let indexLang = document.documentElement.lang
  // Testing Arabic view
  // indexLang = 'ar'
  return indexLang
}

export default pageLanguage
